<ridango-block-full-width [isEmpty]="isEmpty" role="radiogroup" aria-labelledby="product_length_title">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>
    <h2 class="block-full-width__title" id="product_length_title">
        {{ 'CHOOSE_PRODUCT_category_' + type | uppercase | translate }}
    </h2>

    <ridango-block-items-three *ngIf="!isEmpty" ridangoMatchHeight="btn--big-selection__top-wrapper">
        <ridango-selectable-checkable-item
            *ngFor="let pc of categories$ | async; first as isFirst"
            [item]="pc"
            [selected]="pc.id === (selectedCategory$ | async)?.id"
            [locale]="locale"
            [tabIndex]="getTabIndex(pc)"
            (onItemSelected)="productCategorySelected($event)"
            (onMovedLeft)="selectLeft($event)"
            (onMovedRight)="selectRight($event)"
            (onFocused)="focus($event)"
            (onBlurred)="blur($event)"></ridango-selectable-checkable-item>
    </ridango-block-items-three>
</ridango-block-full-width>
